<div class="btn-toolbar" *transloco="let t; read: 'ime.components.action-bar'">
  <router-outlet></router-outlet>
  <button type="button" class="btn btn-outline-primary btn-sm me-1 d-print-none" (click)="actionBarService.addClick$.next()">
    <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus">
    </svg>
    {{t('Add new')}}
  </button>
</div>
